import React, { Component } from "react";
import "react-tabs/style/react-tabs.css";

export default class ContentMessagePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: this.props.showModal || false,
        };
    }

    // Update state when props change
    componentDidUpdate(prevProps) {
        if (prevProps.showModal !== this.props.showModal) {
            this.setState({ showModal: this.props.showModal });
        }
    }

    openModal = () => {
        this.setState({ showModal: true });
    };

 // Update state when props change
    componentDidUpdate(prevProps) {
        if (prevProps.showModal !== this.props.showModal) {
            this.setState({ showModal: this.props.showModal });
        }
    }

    openModal = () => {
        this.setState({ showModal: true });
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    // Handle the "Agree & Proceed" or "Proceed" button click
    handleProceedClick = () => {
        this.closeModal();
        
        // Call parent's onClose callback to trigger redirect
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    // Prevent modal from closing when clicking on modal content
    handleModalContentClick = (e) => {
        e.stopPropagation();
    };


    // Method to be called from parent component
    handlePopupAlertMessage = () => {
        this.openModal();
    };

    handlePopupContentMessage = () => {
        this.openModal();
    };

    render() {
        const { message, guestAgreeFlag } = this.props;
        const { showModal } = this.state;

        if (!message) {
            return null; // Don't render anything if there's no message
        }

        return (
            <>
                {/* Modal backdrop */}
                {showModal && (
                    <div 
                        className="modal-backdrop fade show"
                        onClick={this.closeModal}
                        style={{ zIndex: 1040 }}
                    />
                )}

                {/* Modal */}
                <div
                    className={`modal fade ${showModal ? "show" : ""}`}
                    style={{ 
                        display: showModal ? "block" : "none",
                        zIndex: 1050
                    }}
                    id="alert-message-modal"
                    role="dialog"
                    aria-labelledby="contentModalLabel"
                    aria-hidden={!showModal}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div
                            className="modal-content animate-bottom" onClick={this.handleModalContentClick}
                            style={{ borderRadius: "11px", backgroundColor: "#CEEADC" }}
                        >
                            

                            {/* Modal Body */}
                            <div
                                className="modal-body"
                                id="div-request-body"
                              
                            >
                                <div className="single-item-wrapper">
                                    <div className="single-item">
                                        <div
                                            className="message-container"
                                            style={{
                                                textAlign: "center",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#000",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                userSelect: "none",
                                            }}
                                        >                                            
                                            {/* Display HTML message safely */}
                                            <div 
                                                dangerouslySetInnerHTML={{ __html: message }}
                                                style={{                                                    
                                                    textAlign: "left",
                                                    lineHeight: "1.5",
                                                    userSelect: "none",
                                                    maxHeight: "330px",
                                                    overflowY: "auto",
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Modal Footer */}
                                    <div
                                        className="popup-footer_v2"
                                        style={{ 
                                            justifyContent: "center",
                                            borderTop: "none",
                                          
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            <button
                                                type="button"
                                                style={{
                                                    textAlign: "center",
                                                    backgroundColor: "#18A437",
                                                    boxShadow: "1px 1px 5px 1px rgba(0, 0, 0, 0.25)",
                                                    borderRadius: "7px",
                                                    width: "150px",
                                                    height: "40px",
                                                    cursor: "pointer",
                                                    border: "none",
                                                    fontSize: "14px",
                                                    fontWeight: "600"
                                                }}
                                                className="btn"
                                                 onClick={this.handleProceedClick}
                                            >
                                                {guestAgreeFlag ? "Agree & Proceed" : "Proceed"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}